export default {
    icoev_main_url: 'https://app.icoev.es',
 icoev_service_url : 'https://app.icoev.es/api/v1/',
    icoev_gtag_id: 'G-BXW6YMCGZD',
version : '1.0.38' ,
};